// extracted by mini-css-extract-plugin
export default {"englishMma":"english-mma_englishMma__dImSe"};